import * as React from 'react'

const Handicafe = () => (
  <svg width='11' height='12' viewBox='0 0 11 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.5467 9.11532L9.44588 9.58608L7.90198 6.3252L7.75215 6.0102L7.3897 6.01488L4.05333 6.06L4.02268 5.38248H6.78788V4.32876H3.97703L3.87992 2.14068C4.29547 1.96836 4.58642 1.57476 4.58642 1.1166C4.58654 0.4992 4.06064 0 3.41266 0C2.76342 0 2.23828 0.4992 2.23828 1.1166C2.23828 1.5066 2.44952 1.85016 2.76809 2.04864L2.97038 6.6162L2.99194 7.12776L3.53058 7.1208L7.04188 7.0734L8.66397 10.4965L8.89135 10.9764L9.3943 10.7617L11.0001 10.0757L10.5467 9.11532Z'
      fill='#343434'
    />
    <path
      d='M7.10797 8.83092L6.95915 8.79744C6.6339 10.0628 5.44729 10.9466 4.07616 10.9466C2.43869 10.9466 1.10716 9.68004 1.10716 8.12256C1.10716 7.1634 1.61251 6.28944 2.43995 5.76876L2.29971 4.854L2.2026 4.67676C0.843709 5.34624 0 6.66636 0 8.12256C0 10.2601 1.82867 12.0002 4.07616 12.0002C5.62334 12.0002 6.99648 11.1803 7.68684 9.92184L7.10797 8.83092Z'
      fill='#343434'
    />
  </svg>
)

export default Handicafe



// WEBPACK FOOTER //
// ./src/components/icons/trips/Handicafe.tsx